import React from 'react';
import AdminManagementView from './AdminManagementView';
import AdminManagementLogic from './AdminManagementLogic';

export default function AdminManagement() {
  const {
    admins,
    loading,
    error,
    newAdminEmail,
    handleInputChange,
    handleAddAdmin,
    handleRemoveAdmin,
    success,
    successMessage
  } = AdminManagementLogic();

  return (
    <AdminManagementView
      admins={admins}
      loading={loading}
      error={error}
      newAdminEmail={newAdminEmail}
      onInputChange={handleInputChange}
      onAddAdmin={handleAddAdmin}
      onRemoveAdmin={handleRemoveAdmin}
      success={success}
      successMessage={successMessage}
    />
  );
} 